import React, { useCallback, useEffect, useState } from 'react';
import { AutoComplete, Select } from 'antd';
import { Autocomplete, TextField } from 'react-md';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAmenities,
  getCountryWiseEventType,
  getLocationDetailsByAddress,
  getLocations,
  getLocationsAddress3,
  getPricingOptions,
  getRules,
  getTaxDetails,
  getNearestLocationDetailsByLatLng,
} from '../ListingAction';
import { showErrorMessage } from '../Common/Common';
import PlacesAutocomplete from 'react-places-autocomplete';
import { spaceListingData } from '../Common/ProfileListingDataModal';
import { getLocationDetails, getNearLocation, getLaLong, getLocationByAddress } from '../../../api/getLocationDetails';
import FlowHandlingButtons from '../Common/HandleNavigationAndSubmit';
import { getProfileData, setProfileData } from '../Common/DataController';
import { contentIsNotNull, noSpecialCharIncluded } from '../Common/Validator';
import { COUNTRY_CODES } from '../../Common/constants';
import {
  AUSTRALIA,
  AUSTRALIA_SHORT_CODE,
  AUSTRALIA_CURRENCY,
  DEFAULT_DATA_OBJ,
  ERROR_CHAR_LIMIT,
  ERROR_SPECIAL_CHAR,
  ERROR_WHITE_SPACE,
  SINGAPORE,
  SINGAPORE_CURRENCY,
  SINGAPORE_SHORT_CODE,
  SRI_LANKA,
  SRI_LANKA_CURRENCY,
  SRI_LANKA_SHORT_CODE,
} from '../SpaceListingConstants';
import { useParams, useLocation } from 'react-router-dom';

let previousCountry = null;
let autocompleteServiceInstance = null;
let geocoderInstance = null;

const { Option } = Select;
const SpaceLocation = ({ currentBlock, handleMapSet, handleNearestlocation }) => {
  const [disable, setDisable] = useState(true);
  const { country } = useParams();
  const dispatch = useDispatch();
  const locationSuggestions = useSelector((state) => state?.spaceListing?.locationSearch);
  const locationSuggestionsAdd3 = useSelector((state) => state?.spaceListing?.locationSearchAddress3);
  const location = useLocation();
  const mapPinChanged = useSelector((state) => state?.spaceListing?.mapPinUpdatedTime);
  const mapZoomUpdated = useSelector((state) => state?.spaceListing?.mapZoomUpdated);
  const mrtSections = useSelector((state) => state?.spaceListing?.mrtStations?.locations);
  const rules = useSelector((state) => state?.spaceListing?.rules);
  const amenities = useSelector((state) => state?.spaceListing?.amenities);
  const [spaceLocation, setSpaceLocation] = useState(getProfileData()?.[DEFAULT_DATA_OBJ] ? getProfileData() : spaceListingData(country));
  const [isNextBtnActive, setIsNextBtnActive] = useState(false);
  const coordinates = useSelector((state) => state?.spaceListing?.coordinates);
  const [stateAndPostal, setStateAndPostal] = useState();
  const countryShortCode = useSelector((state) => state?.locationMeta?.data?.country_shortCode || 'LK');
  const countryLongCode = useSelector((state) => state?.locationMeta?.data?.country_longCode || 'SRI_LANKA');
  const nearestLocations = useSelector((state) => state?.spaceListing?.nearestLocations);
  const distance = useSelector((state) => state?.spaceListing?.nearestLocations?.distanceToStation);
  const subwayname = useSelector((state) => state?.spaceListing?.nearestLocations?.railwayName);
  const latitude = useSelector((state) => state?.spaceListing?.nearestLocations?.lat2);
  const longitude = useSelector((state) => state?.spaceListing?.nearestLocations?.lng2);
  const [mapSearchText, setMapSearchText] = useState('');
  const [mapSearchOptions, setMapSearchOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const autocompleteInputRef = React.useRef(null);

  const parseAddressResult = (result, countryCode) => {
    if (!result) return {};
    
    const addressComponents = result.address_components || [];
    const formattedAddress = result.formatted_address || '';
    
    let newCity = '';
    let newPostalCode = '';
    let newStreetName = '';
    let newSuburb = '';

    addressComponents.forEach(comp => {
      // City Fallbacks
      if (comp.types.includes('locality')) {
        newCity = comp.long_name;
      } else if (!newCity && comp.types.includes('sublocality_level_1')) {
        newCity = comp.long_name;
      } else if (!newCity && comp.types.includes('administrative_area_level_2')) {
        newCity = comp.long_name;
      } else if (!newCity && comp.types.includes('neighborhood')) {
        newCity = comp.long_name;
      }

      // Postal Code
      if (comp.types.includes('postal_code')) {
        newPostalCode = comp.long_name;
      }

      // Street Name Fallbacks
      if (comp.types.includes('route')) {
        newStreetName = comp.long_name;
      } else if (!newStreetName && comp.types.includes('neighborhood')) {
        newStreetName = comp.long_name;
      } else if (!newStreetName && comp.types.includes('sublocality_level_2')) {
        newStreetName = comp.long_name;
      } else if (!newStreetName && comp.types.includes('premise')) {
        newStreetName = comp.long_name;
      } else if (!newStreetName && comp.types.includes('sublocality')) {
        newStreetName = comp.long_name;
      }

      // Suburb
      if (comp.types.includes('administrative_area_level_2') || comp.types.includes('locality')) {
        newSuburb = comp.long_name;
      }
    });

    // Postcode fallback extraction using regex if addressComponents didn't have it
    if (!newPostalCode && formattedAddress) {
      const cleanAddress = formattedAddress.trim();
      const codeUpper = (countryCode || '').toUpperCase();
      
      if (codeUpper === 'SG' || codeUpper === 'SINGAPORE') {
        const match = cleanAddress.match(/\b\d{6}\b/);
        if (match) newPostalCode = match[0];
      } else if (codeUpper === 'LK' || codeUpper === 'SRI_LANKA' || codeUpper === 'SRI LANKA') {
        const match = cleanAddress.match(/\b\d{5}\b/);
        if (match) newPostalCode = match[0];
      } else if (codeUpper === 'AUS' || codeUpper === 'AUSTRALIA') {
        const match = cleanAddress.match(/\b\d{4}\b/);
        if (match) newPostalCode = match[0];
      } else {
        const match = cleanAddress.match(/\b\d{4,6}\b/);
        if (match) newPostalCode = match[0];
      }
    }

    return {
      newCity,
      newPostalCode,
      newStreetName,
      newSuburb,
      formattedAddress
    };
  };

  const handleMapSearchChange = (value) => {
    setMapSearchText(value);
    if (value && value.length > 2 && window.google) {
      if (!autocompleteServiceInstance) {
        autocompleteServiceInstance = new window.google.maps.places.AutocompleteService();
      }
      autocompleteServiceInstance.getPlacePredictions(
        {
          input: value,
          componentRestrictions: { country: getFieldCurrentValue('countryCode')?.toLowerCase() || 'lk' }
        },
        (predictions, status) => {
          if (status === 'OK' && predictions) {
            setMapSearchOptions(predictions);
            setShowDropdown(true);
          }
        }
      );
    } else {
      setMapSearchOptions([]);
      setShowDropdown(false);
    }
  };

  const handleMapSearchSelect = (description, placeId) => {
    setMapSearchText(description);
    setShowDropdown(false);
    const placeId_ = placeId;

    if (!window.google) return;

    if (!geocoderInstance) {
      geocoderInstance = new window.google.maps.Geocoder();
    }
    geocoderInstance.geocode({ placeId: placeId_ }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const lat = results[0].geometry.location.lat();
        const lng = results[0].geometry.location.lng();
        
        const parsed = parseAddressResult(results[0], getFieldCurrentValue('countryCode') || getFieldCurrentValue('spaceCountry'));

        // Update the form fields AND move the map pin all at once!
        const tempObj = Object.assign({}, spaceLocation, {
          ...spaceLocation,
          processStarted: true,
          [currentBlock]: spaceLocation[currentBlock].map((val) => {
            return {
              ...val,
              latitude: lat,
              longitude: lng,
              city: parsed.newCity || val.city,
              postalCode: parsed.newPostalCode || val.postalCode,
              streetName: parsed.newStreetName || val.streetName,
              postalAddress: parsed.formattedAddress,
              addressLine1: parsed.newStreetName || val.addressLine1,
              addressLine3: parsed.newSuburb || val.addressLine3,
              postcode: parsed.newPostalCode || val.postcode,
            };
          }),
        });

        setSpaceLocation(tempObj);
        setProfileData(tempObj);
        handleMapSet(tempObj); // This instantly moves the pin on the right side!
      }
    });
  };

  const updateCoordsOnly = (lat, lng) => {
    setSpaceLocation((prevSpaceLocation) => {
      const tempObj = Object.assign({}, prevSpaceLocation, {
        ...prevSpaceLocation,
        processStarted: true,
        [currentBlock]: prevSpaceLocation[currentBlock].map((val) => {
          return {
            ...val,
            latitude: lat,
            longitude: lng,
          };
        }),
      });
      setProfileData(tempObj);
      handleMapSet(tempObj);
      return tempObj;
    });
  };

  useEffect(() => {
    if (countryShortCode === 'AUS' || getFieldCurrentValue('spaceCountry') === AUSTRALIA) {
      setIsNextBtnActive(contentIsNotNull(getFieldCurrentValue('addressLine1'), 0) && contentIsNotNull(getFieldCurrentValue('addressLine3'), 0));
    } else {
      setIsNextBtnActive(
        contentIsNotNull(getFieldCurrentValue('streetName'), 3,500) &&
          contentIsNotNull(getFieldCurrentValue('postalCode'), 0, 15) &&
          contentIsNotNull(getFieldCurrentValue('city'), 0, 100) &&
          //contentIsNotNull(getFieldCurrentValue('streetName'), 8, 500) &&
          contentIsNotNull(getFieldCurrentValue('postalAddress'), 8) &&
          (getFieldCurrentValue('spaceCountry') === SINGAPORE
            ? !getFieldCurrentValue('mrtStatus') ||
              (contentIsNotNull(getFieldCurrentValue('mrtStatus')?.toString(), 0) && getFieldCurrentValue('mrtSections')?.length > 0)
            : contentIsNotNull(getFieldCurrentValue('isParkingAvailable')?.toString(), 0))
      );
    }
  }, [spaceLocation]);

  useEffect(() => {
    dispatch(getNearestLocationDetailsByLatLng(spaceLocation?.[currentBlock]?.[0]?.latitude, spaceLocation?.[currentBlock]?.[0]?.longitude));
  }, [spaceLocation?.[currentBlock]?.[0]?.latitude, spaceLocation?.[currentBlock]?.[0]?.longitude]);

  useEffect(() => {
    handleSpaceLocation('subwayname', subwayname);
    handleSpaceLocation('publicTransportAccess', distance);
    handleNearestlocation(latitude, longitude);
  }, [nearestLocations]);

  useEffect(() => {
    if (!rules || !amenities) return;
    
    const tempObj = Object.assign({}, spaceLocation, {
      ...spaceLocation,
      processStarted: true,
      rules: [{ data: rules }],
      amenities: [{ data: amenities }],
    });
    setSpaceLocation(() => tempObj);
    setProfileData(tempObj);
  }, [rules, amenities]);

  useEffect(() => {
    if (previousCountry !== countryShortCode) {
      const result = countryShortCode === 'SG' ? SINGAPORE : countryShortCode === 'AUS' ? AUSTRALIA : SRI_LANKA;
      handleCountryAndMap(result);

      previousCountry = countryShortCode;
    }
  }, [countryShortCode]);

  useEffect(() => {
    if (coordinates?.lat && coordinates?.lng) {
      setSpaceLocation((prevSpaceLocation) => {
        const tempObj = Object.assign({}, prevSpaceLocation, {
          ...prevSpaceLocation,
          processStarted: true,
          [currentBlock]: prevSpaceLocation[currentBlock].map((val) => {
            return {
              ...val,
              latitude: Number(coordinates.lat),
              longitude: Number(coordinates.lng),
            };
          }),
        });
        setProfileData(tempObj);
        handleMapSet(tempObj);
        return tempObj;
      });
    }
  }, [coordinates]);

  const getFieldCurrentValue = (type) => {
    return spaceLocation?.[currentBlock]?.[0]?.[type];
  };

  const filteredLocations = Array.from(new Set((locationSuggestions || []).map(option => option.title)));

  const address = () => {
    switch (getFieldCurrentValue('spaceCountry')) {
      case AUSTRALIA:
        return (
          getFieldCurrentValue('addressLine1') +
          ' ' +
          getFieldCurrentValue('addressLine2') +
          ' ' +
          getFieldCurrentValue('addressLine3') +
          ' ' +
          getFieldCurrentValue('postcode') +
          ' ' +
          'Australia'
        );
      case SINGAPORE:
        return getFieldCurrentValue('postalCode') + ' ' + getFieldCurrentValue('city') + ' ' + getFieldCurrentValue('streetName') + ' ' + 'Singapore';
      default:
        return getFieldCurrentValue('postalCode') + ' ' + getFieldCurrentValue('city') + ' ' + getFieldCurrentValue('streetName') + ' ' + 'Sri Lanka';
    }
  };

  const handleSpaceLocation = (name, newValue, max = 5000, noSpecialChar = false, noWhiteSpaces = false) => {
    const valueStr = newValue?.toString() || '';
    if (valueStr.length > max) {
      showErrorMessage(ERROR_CHAR_LIMIT);
    } else if (noSpecialChar && !noSpecialCharIncluded(valueStr)) {
      showErrorMessage(ERROR_SPECIAL_CHAR);
    } else if (noWhiteSpaces && /\s/g.test(valueStr)) {
      showErrorMessage(ERROR_WHITE_SPACE);
    } else {
      const tempObj = Object.assign({}, spaceLocation, {
        ...spaceLocation,
        processStarted: true,
        [currentBlock]: spaceLocation?.[currentBlock].map((value) => {
          value[name] = newValue;
          return value;
        }),
      });

      if (name === 'longitude' || name === 'latitude') {
        handleMapSet(tempObj);
      }
      setSpaceLocation(tempObj);
      setProfileData(tempObj);
    }
  };

  const handleCommissionDetails = (name, newValue) => {
    const tempObj = Object.assign({}, spaceLocation, {
      ...spaceLocation,
      processStarted: true,
      commission: spaceLocation?.commission.map((value) => {
        value[name] = newValue;
        return value;
      }),
    });
    setSpaceLocation(tempObj);
    setProfileData(tempObj);
  };

  const handleTaxDetails = (name, newValue) => {
    const tempObj = Object.assign({}, spaceLocation, {
      ...spaceLocation,
      processStarted: true,
      tax_information: spaceLocation?.tax_information.map((value) => {
        value[name] = newValue;
        return value;
      }),
    });
    setSpaceLocation(tempObj);
    setProfileData(tempObj);
  };

  const handleCountryAndMap = (value) => {
    const routingObj = Object.assign({}, spaceLocation, {
      ...spaceLocation,
      processStarted: true,
      routeList: spaceLocation?.routeList.filter((value) => {
        return !value?.includes('addons');
      }),
    });

    let currentLocBlock = Object.assign({}, routingObj[currentBlock]?.[0] || {});
    
    currentLocBlock = {
      ...currentLocBlock,
      streetName: '',
      city: '',
      postalAddress: '',
      spaceCountry: value,
    };

    if (value === SRI_LANKA) {
      if (routingObj && routingObj.routeList) {
        routingObj.routeList.splice(
          routingObj.routeList.indexOf('/dashboard/list-a-space/amenities') + 1,
          0,
          '/dashboard/list-a-space/addons'
        );
      }
      dispatch(getTaxDetails(SRI_LANKA_SHORT_CODE));
      dispatch(getAmenities(SRI_LANKA_SHORT_CODE));
      dispatch(getRules(SRI_LANKA_SHORT_CODE));
      handleTaxDetails('currency', SRI_LANKA_CURRENCY);
      handleCommissionDetails('percentage', 15);
      
      currentLocBlock.latitude = COUNTRY_CODES.SRI_LANKA.lat;
      currentLocBlock.longitude = COUNTRY_CODES.SRI_LANKA.lng;
      currentLocBlock.countryCode = SRI_LANKA_SHORT_CODE;
      currentLocBlock.mapZoom = 8;
      
      dispatch(getCountryWiseEventType(SRI_LANKA_SHORT_CODE));
      dispatch(getPricingOptions(SRI_LANKA_SHORT_CODE));
    } else if (value === AUSTRALIA) {
      dispatch(getTaxDetails(AUSTRALIA_SHORT_CODE));
      dispatch(getAmenities(AUSTRALIA_SHORT_CODE));
      dispatch(getRules(AUSTRALIA_SHORT_CODE));
      handleTaxDetails('currency', AUSTRALIA_CURRENCY);
      handleCommissionDetails('percentage', 10);
      
      currentLocBlock.latitude = COUNTRY_CODES.AUSTRALIA.lat;
      currentLocBlock.longitude = COUNTRY_CODES.AUSTRALIA.lng;
      currentLocBlock.countryCode = AUSTRALIA_SHORT_CODE;
      currentLocBlock.mapZoom = 8;
      
      dispatch(getCountryWiseEventType(AUSTRALIA_SHORT_CODE));
      dispatch(getPricingOptions(AUSTRALIA_SHORT_CODE));

      currentLocBlock.addressLine1 = '';
      currentLocBlock.addressLine2 = '';
      currentLocBlock.addressLine3 = '';
      currentLocBlock.publicTransportAccess = 0.1;
    } else {
      dispatch(getTaxDetails(SINGAPORE_SHORT_CODE));
      dispatch(getAmenities(SINGAPORE_SHORT_CODE));
      dispatch(getRules(SINGAPORE_SHORT_CODE));
      handleTaxDetails('currency', SINGAPORE_CURRENCY);
      handleCommissionDetails('percentage', 10);
      
      currentLocBlock.latitude = COUNTRY_CODES.SINGAPORE.lat;
      currentLocBlock.longitude = COUNTRY_CODES.SINGAPORE.lng;
      currentLocBlock.countryCode = SINGAPORE_SHORT_CODE;
      currentLocBlock.mapZoom = 8;
      
      dispatch(getCountryWiseEventType(SINGAPORE_SHORT_CODE));
      dispatch(getPricingOptions(SINGAPORE_SHORT_CODE));
    }

    const tempObj = {
      ...routingObj,
      [currentBlock]: [currentLocBlock],
    };

    handleMapSet(tempObj);
    setSpaceLocation(tempObj);
    setProfileData(tempObj);
  };

  const handleSearch = (value, name) => {
    switch (name) {
      case 'streetName':
        handleSpaceLocation('streetName', value);
        dispatch(getLocations(value, getFieldCurrentValue('countryCode')));
        break;

      case 'addressLine3':
        handleSpaceLocation('addressLine3', value);
        dispatch(getLocationsAddress3(value, getFieldCurrentValue('countryCode')));
        break;

      default:
        handleSpaceLocation('streetName', value);
        dispatch(getLocations(value, getFieldCurrentValue('countryCode')));
        break;
    }
  };

  useEffect(() => {
    if (mapPinChanged?.time) {
      const lat = Number(mapPinChanged?.latitude);
      const lng = Number(mapPinChanged?.longitude);

      if (window.google) {
        if (!geocoderInstance) {
          geocoderInstance = new window.google.maps.Geocoder();
        }
        geocoderInstance.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results[0]) {
            const parsed = parseAddressResult(results[0], getFieldCurrentValue('countryCode') || getFieldCurrentValue('spaceCountry'));

            setSpaceLocation((prevSpaceLocation) => {
              const tempObj = Object.assign({}, prevSpaceLocation, {
                ...prevSpaceLocation,
                processStarted: true,
                [currentBlock]: prevSpaceLocation[currentBlock].map((val) => {
                  return {
                    ...val,
                    latitude: lat,
                    longitude: lng,
                    city: parsed.newCity || val.city,
                    postalCode: parsed.newPostalCode || val.postalCode,
                    streetName: parsed.newStreetName || val.streetName,
                    postalAddress: parsed.formattedAddress,
                    addressLine1: parsed.newStreetName || val.addressLine1,
                    addressLine3: parsed.newSuburb || val.addressLine3,
                    postcode: parsed.newPostalCode || val.postcode,
                  };
                }),
              });
              setProfileData(tempObj);
              handleMapSet(tempObj);
              return tempObj;
            });
          } else {
            updateCoordsOnly(lat, lng);
          }
        });
      } else {
        updateCoordsOnly(lat, lng);
      }
    }
  }, [mapPinChanged]);

  useEffect(() => {
    if (mapZoomUpdated) {
      handleSpaceLocation('mapZoom', Number(mapZoomUpdated?.mapZoom), 25);
    }
  }, [mapZoomUpdated]);

  useEffect(() => {
    if (
      contentIsNotNull(getFieldCurrentValue('addressLine1'), 3) &&
      contentIsNotNull(getFieldCurrentValue('addressLine3'), 3) &&
      contentIsNotNull(getFieldCurrentValue('postcode'), 3)
    ) {
      dispatch(getLocationDetailsByAddress(address()));
    }
  }, [getFieldCurrentValue('postcode')]);

  const getLocationAddressCompleted = () => {
    if (
      contentIsNotNull(getFieldCurrentValue('streetName'), 0) &&
      contentIsNotNull(getFieldCurrentValue('postalCode'), 0, 15) &&
      contentIsNotNull(getFieldCurrentValue('city'), 0, 100) &&
      contentIsNotNull(getFieldCurrentValue('postalAddress'), 8)
    ) {
      dispatch(getLocationDetailsByAddress(address()));
    }
    if (
      contentIsNotNull(getFieldCurrentValue('addressLine1'), 3) &&
      contentIsNotNull(getFieldCurrentValue('addressLine3'), 3) &&
      contentIsNotNull(getFieldCurrentValue('postcode'), 3)
    ) {
      dispatch(getLocationDetailsByAddress(address()));
    }
  };


  const __renderAusAddressFields = () => {
    return (
      <>
        <TextField
          className="input-margin-wrapper"
          id="addressLine1"
          label="Address Line 1"
          lineDirection="center"
          errorText="This field is required."
          onChange={(value) => {
            handleSpaceLocation('addressLine1', value);
            getLocationAddressCompleted();
          }}
          value={getFieldCurrentValue('addressLine1')}
          // onBlur={() => getLocationAddressCompleted()}
        />

        <TextField
          className="input-margin-wrapper"
          id="addressLine2"
          label="Address Line 2 (Optional)"
          lineDirection="center"
          onChange={(value) => {
            handleSpaceLocation('addressLine2', value);
            getLocationAddressCompleted();
          }}
          value={getFieldCurrentValue('addressLine2')}
          // onBlur={() => getLocationAddressCompleted()}
        />

        <div className="sl-custom-field-wrapper">
          <label className="sl-custom-label">Suburb</label>
          <AutoComplete
            className={`street-name-selector ${getFieldCurrentValue('addressLine3')?.length > 0 ? 'placeHolderTop' : ''}`}
            defaultValue={getFieldCurrentValue('addressLine3')}
            onSearch={(val) => handleSearch(val, 'addressLine3')}
            placeholder="Suburb"
            onSelect={(values) => {
              setStateAndPostal(values);
              handleSpaceLocation('addressLine3', values?.split(',')?.[0]);
              handleSpaceLocation('postcode', values?.split(',')?.[1]);
            }}
          >
            {locationSuggestionsAdd3?.map((location) => (
              <Option value={location?.title}>{location?.title?.split(',')?.[0]}</Option>
            ))}
          </AutoComplete>
        </div>

        <TextField
          className={`input-margin-wrapper ${getFieldCurrentValue('postcode')?.length > 0 ? 'placeHolderTop' : ''}`}
          id="postcode"
          label="State/Postcode"
          lineDirection="center"
          value={getFieldCurrentValue('postcode')}
          onChange={(value) => {
            handleSpaceLocation('postcode', value);
            getLocationAddressCompleted();
          }}
          defaultValue={getFieldCurrentValue('postcode')}
          // onBlur={() => getLocationAddressCompleted()}
        />
      </>
    );
  };

  const __renderPublicAccess = () => {
    return (
      <>
        <div className="flex-wrap mb-15">
          <span className="gray-text custom-gray-txt">PUBLIC TRANSPORT ACCESS</span>
          <hr className="divider cutome-gray-divider" />
        </div>
        <TextField
          className="input-margin-wrapper"
          id="subway"
          label="Nearest Railway Station"
          lineDirection="center"
          disabled={disable}
          onChange={(subwayname) => handleSpaceLocation('subwayname', subwayname)}
          value={getFieldCurrentValue('subwayname')}
        />
        <div className="position-relative">
          <TextField
            className="input-margin-wrapper"
            id="publicTransportAccess"
            type={'number'}
            disabled={disable}
            label="Distance to Nearest Public Transport (km)"
            lineDirection="center"
            errorText="This field is required."
            step="0.1"
            onChange={(value) => handleSpaceLocation('publicTransportAccess', value)}
            value={getFieldCurrentValue('publicTransportAccess')}
          />
          <span className="superfix">km</span>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="left-side-inner-wrapper space-location-wrapper">
        <h1 className="listing-page-title">Space Location</h1>
        
        <div className="sl-custom-field-wrapper">
          <label className="sl-custom-label">Country</label>
          <Select
            className={`input-margin-wrapper ${getFieldCurrentValue('spaceCountry')?.length > 0 ? 'placeHolderTop' : ''} country-disable `}
            value={getFieldCurrentValue('spaceCountry')}
            placeholder={'Country'}
            dropdownClassName="space-listing-drop-down "
            onSelect={(value) => handleCountryAndMap(value)}
            defaultValue={countryLongCode}
            disabled
          >
            <Option value={SRI_LANKA}>Sri Lanka</Option>
          </Select>
        </div>

        <div className="sl-custom-field-wrapper">
          <label className="sl-custom-label">Search Location</label>
          <div
            ref={autocompleteInputRef}
            className="sl-search-wrapper"
          >
            <input
              type="text"
              value={mapSearchText}
              onChange={(e) => handleMapSearchChange(e.target.value)}
              onFocus={() => mapSearchOptions.length > 0 && setShowDropdown(true)}
              onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
              placeholder="Search for a building, street, or area..."
              className="sl-search-input"
              onKeyDown={(e) => {
                if (e.key === 'Escape') setShowDropdown(false);
              }}
            />
            {showDropdown && mapSearchOptions.length > 0 && (
              <ul className="sl-search-dropdown">
                {mapSearchOptions.map((option) => (
                  <li
                    key={option.place_id}
                    onMouseDown={() => handleMapSearchSelect(option.description, option.place_id)}
                    className="sl-search-option"
                  >
                    {option.description}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      
        {getFieldCurrentValue('spaceCountry') === AUSTRALIA && __renderAusAddressFields()}

        {getFieldCurrentValue('spaceCountry') !== AUSTRALIA && (
          <div>
            <div className="sl-field-grid">
              <TextField
                className="input-margin-wrapper"
                id="city"
                label="City"
                lineDirection="center"
                errorText="This field is required."
                onChange={(value) => handleSpaceLocation('city', value)}
                value={getFieldCurrentValue('city')}
                onBlur={() => getLocationAddressCompleted()}
              />

              <TextField
                className="input-margin-wrapper"
                id="postalCode"
                label="Postal Code"
                lineDirection="center"
                errorText="This field is required."
                onChange={(value) => handleSpaceLocation('postalCode', value)}
                value={getFieldCurrentValue('postalCode')}
                onBlur={() => getLocationAddressCompleted()}
              />
            </div>

            <TextField
              className="input-margin-wrapper"
              id="streetName"
              label="Street Name"
              lineDirection="center"
              errorText="This field is required."
              onChange={(value) => handleSpaceLocation('streetName', value)}
              value={getFieldCurrentValue('streetName')}
              onBlur={() => getLocationAddressCompleted()}
            />

            <TextField
              className="input-margin-wrapper"
              id="postalAddress"
              label="Postal Address"
              lineDirection="center"
              errorText="This field is required."
              onChange={(value) => handleSpaceLocation('postalAddress', value)}
              value={getFieldCurrentValue('postalAddress')}
              onBlur={() => getLocationAddressCompleted()}
            />
          </div>
        )}

        {/*<hr className="divider" />
          <TextField
            className="input-margin-wrapper"
            id="latitude"
            label="Latitude"
            lineDirection="center"
            type={"number"}
            errorText="This field is required."
            onChange={(value) => handleSpaceLocation("latitude", Number(value), 25)}
            value={getFieldCurrentValue("latitude")}
          />

          <TextField
            className="input-margin-wrapper"
            id="longitude"
            label="Longitude"
            lineDirection="center"
            type={"number"}
            errorText="This field is required."
            onChange={(value) => handleSpaceLocation("longitude", Number(value), 25)}
            value={getFieldCurrentValue("longitude")}
          /> */}

        {getFieldCurrentValue('spaceCountry') === AUSTRALIA ? __renderPublicAccess() : null}

        {getFieldCurrentValue('spaceCountry') === SINGAPORE ? (
          <div>
            <div className="sl-custom-field-wrapper">
              <label className="sl-custom-label">MRT Status</label>
              <Select
                className={`input-margin-wrapper pricing-options input-mrt ${getFieldCurrentValue('mrtStatus')?.length > 0 ? 'placeHolderTop' : ''}`}
                dropdownClassName="space-listing-drop-down"
                placeholder="MRT Status"
                onChange={(value) => handleSpaceLocation('mrtStatus', value)}
                value={getFieldCurrentValue('mrtStatus')}
              >
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </div>

            {getFieldCurrentValue('mrtStatus') && (
              <div className="sl-custom-field-wrapper">
                <label className="sl-custom-label">MRT Locations</label>
                <Select
                  className={`input-margin-wrapper pricing-options ${getFieldCurrentValue('mrtSections')?.length > 0 ? 'placeHolderTop' : ''}`}
                  dropdownClassName="space-listing-drop-down"
                  mode="multiple"
                  allowClear
                  placeholder="MRT Locations"
                  onChange={(value) => handleSpaceLocation('mrtSections', value)}
                  value={getFieldCurrentValue('mrtSections')}
                >
                  {mrtSections.map((value) => (
                    <Option key={value || 'Error Occurred'}>{value}</Option>
                  ))}
                </Select>
              </div>
            )}
          </div>
        ) : (
          <div>
            {getFieldCurrentValue('spaceCountry') !== AUSTRALIA && (
              <div className="sl-custom-field-wrapper">
                <label className="sl-custom-label">Parking Available</label>
                <Select
                  className={`input-margin-wrapper parking-available-input ${
                    getFieldCurrentValue('isParkingAvailable')?.length > 0 ? 'placeHolderTop' : ''
                  }`}
                  dropdownClassName="space-listing-drop-down"
                  placeholder="Parking Available"
                  onChange={(value) => handleSpaceLocation('isParkingAvailable', value)}
                  value={getFieldCurrentValue('isParkingAvailable')}
                >
                  <Option value={true}>Yes</Option>
                  <Option value={false}>No</Option>
                </Select>
              </div>
            )}
          </div>
        )}
      </div>
      <FlowHandlingButtons isActive={isNextBtnActive} />
    </>
  );
};

export default SpaceLocation;
